<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item active">Настройки</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<h5>Настройки</h5>
			<div class="text-muted">Редактирование настроек</div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="init">
			<div class="spinner-border" style="width: 100px; height: 100px;"></div>
		</div>
		<div class="card" v-else>
			<div class="card-header">
				<ul class="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
					<li class="nav-item" role="presentation">
						<button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#settings-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Настройки</button>
					</li>
					<li class="nav-item" role="presentation">
						<button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="афдыу">Содержимое главной страницы</button>
					</li>
					<li class="nav-item" role="presentation">
						<button class="nav-link" id="sidebar2-tab" data-bs-toggle="tab" data-bs-target="#sidebar2-tab-pane" type="button" role="tab" aria-controls="sidebar2-tab-pane" aria-selected="false">Доп. кнопки в меню слева</button>
					</li>
				</ul>
			</div>
			<div class="card-body">
				<div class="tab-content" id="myTabContent">
					<form @submit.prevent="saveSettings()" class="tab-pane fade show active" id="settings-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
						<div class="card mb-3">
							<div class="card-body">
								<div>
									<div class="form-check form-switch">
										<label class="form-check-label" for="switchSettingsEnableRegister">Разрешить регистрацию пользователей</label>
										<input class="form-check-input" type="checkbox" role="switch" id="switchSettingsEnableRegister" v-model="enableRegister" :disabled="loadingSettings" />
									</div>
								</div>
							</div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="d-grid gap-2 d-md-flex justify-content-md-end">
									<button
										type="submit"
										class="btn btn-primary d-flex align-items-center justify-content-center"
										:disabled="loadingSettings"
									>
										<div v-if="loadingSettings" class="spinner-border spinner-border-sm me-2"></div>
										<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
											<path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
										</svg>
										<span class="ms-2">{{ loadingSettings ? 'Сохранение...' : 'Сохранить изменения' }}</span>
									</button>
								</div>
							</div>
						</div>
					</form>
					<form @submit.prevent="saveSettings()" class="tab-pane fade" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
						<div class="mb-3">
							<vue-codemirror
								v-model="contentMainpage"
								placeholder="Содержимое главной страницы..."
								:style="{ height: '400px' }"
								:disabled="loadingSettings"
							/>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="d-grid gap-2 d-md-flex justify-content-md-end">
									<button
										type="submit"
										class="btn btn-primary d-flex align-items-center justify-content-center"
										:disabled="loadingSettings"
									>
										<div v-if="loadingSettings" class="spinner-border spinner-border-sm me-2"></div>
										<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
											<path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
										</svg>
										<span class="ms-2">{{ loadingSettings ? 'Сохранение...' : 'Сохранить изменения' }}</span>
									</button>
								</div>
							</div>
						</div>
					</form>
					<form @submit.prevent="saveSidebar2()" class="tab-pane fade" id="sidebar2-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
						<div class="mb-3">
							<div class="card">
								<draggable 
									v-model="sidebar2" 
									item-key="index" 
									handle=".drag-handle" 
									ghost-class="bg-light"
								>
									<template #item="{ element, index }">
										<div class="card-body border-bottom">
											<div class="row align-items-center">
												<!-- Хендл для перетаскивания -->
												<div class="col-md-auto pe-0 drag-handle" style="cursor: grab;">
													<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="text-muted">
														<path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm10-12a2 2 0 1 0 .001 4.001A2 2 0 0 0 17 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 17 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 17 14z"/>
													</svg>
												</div>
												
												<div class="col-md-3 mb-3 mb-md-0">
													<label :for="'inputText' + index" class="form-label">Текст кнопки</label>
													<input class="form-control" type="text" :id="'inputText' + index" v-model="element.text" :disabled="loadingSidebar2" required />
												</div>
												<div class="col mb-3 mb-md-0">
													<label :for="'inputLink' + index" class="form-label">Ссылка</label>
													<input class="form-control" type="text" :id="'inputLink' + index" v-model="element.link" :disabled="loadingSidebar2" required />
												</div>
												<div class="col-md-2 mb-3 mb-md-0 d-flex justify-content-between d-md-block">
													<label class="form-check-label" :for="'switchTargetBlank' + index">Открывать в новой вкладке?</label>
													<div class="form-check form-switch">
														<input class="form-check-input" type="checkbox" role="switch" :id="'switchTargetBlank' + index" :disabled="loadingSidebar2" v-model="element.isTargetBlank" />
													</div>
												</div>
												<div class="col-md-1 text-end">
													<div class="btn btn-danger d-flex d-md-inline-block align-items-center justify-content-center" title="Удалить" v-tippy="{placement: 'top'}" :disabled="loadingSidebar2" @click="deleteSidebar2Link(index)">
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
															<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
														</svg>
													</div>
												</div>
											</div>
										</div>
									</template>
								</draggable>
								<div class="card-footer border-0 text-end">
									<button type="button" @click="addSidebar2Link" class="btn btn-primary">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
											<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
										</svg>
										<span class="ms-2">Добавить кнопку</span>
									</button>
								</div>
							</div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="d-grid gap-2 d-md-flex justify-content-md-end">
									<button
										type="submit"
										class="btn btn-primary d-flex align-items-center justify-content-center"
										:disabled="loadingSidebar2"
									>
										<div v-if="loadingSidebar2" class="spinner-border spinner-border-sm me-2"></div>
										<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
											<path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
										</svg>
										<span class="ms-2">{{ loadingSidebar2 ? 'Сохранение...' : 'Сохранить изменения' }}</span>
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import draggable from 'vuedraggable';

export default {
	mixins: lib.mixins,
	setup() {
		useMeta({title: 'Настройки | SKV'});
	},
	data: () => ({
		init: false,
		
		enableRegister: false,
		contentMainpage: '',
		loadingSettings: false,
		
		sidebar2: [],
		loadingSidebar2: false,
	}),
	methods: {
		async loadSettings() {
			const [resSet, resLinks] = await Promise.all([
				this.appModel.doGetSettings(),
				this.appModel.doGetSidebarLinks(),
			]);
			
			if (resSet) {
				const { enable_register, content_mainpage } = resSet;
				this.enableRegister = !!enable_register;
				this.contentMainpage = content_mainpage;
			}
			if (resLinks) {
				this.sidebar2 = resLinks.map(({ text, link, is_target_blank }) => ({
					text,
					link,
					isTargetBlank: !!is_target_blank,
				}));
			}
		},
		
		async saveSettings() {
			this.loadingSettings = true;
			try {
				const result = await this.appModel.doSaveSettings({
					enableRegister: this.enableRegister ? 1 : 0,
					contentMainpage: this.contentMainpage,
				});
				if (result.success) {
					this.appModel.enableRegister = this.enableRegister;
					this.appModel.contentMainpage = this.contentMainpage;
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.loadingSettings = false;
			}
		},
		
		addSidebar2Link() {
			this.sidebar2.push({
				text: '',
				link: '',
				isTargetBlank: false,
			});
		},
		deleteSidebar2Link(index) {
			if (confirm('Вы уверены?')) {
				this.sidebar2.splice(index, 1);
			}
		},
		async saveSidebar2() {
			this.loadingSidebar2 = true;
			try {
				// Отправляем весь массив ссылок для полной синхронизации
				const result = await this.appModel.doSaveSidebarLinks({
					links: this.sidebar2,
				});
				if (result.success) {
					this.appModel.sidebar2 = JSON.parse(JSON.stringify(this.sidebar2));
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.loadingSidebar2 = false;
			}
		},
	},
	async mounted() {
		this.init = true;
		await this.loadSettings();
		this.init = false;
	},
	components: {
		draggable,
	},
};
</script>
